export default __webpack_public_path__ + "static/media/logo-1.100e619c.webp";